import { GenericAlarm } from '../generic-alarm';
import { isArray } from 'util';
import { ControlBuilder } from './control.builder';
import { GenericAlarmFormatBuilder } from './generic-alarm-format.builder';

export class GenericAlarmBuilder {
  static fromJson(json) {
    return (json)
      ? new GenericAlarm(
        json.hash,
        json.active,
        GenericAlarmFormatBuilder.fromJson(json.format),
        json.dateRegex,
        json.genericTxt,
        ControlBuilder.fromJson(json.control),
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(GenericAlarmBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/generic-alarm.builder.ts